export default __webpack_public_path__ + "/images/alarm_clock.png";